import { confidenceGateMessages } from 'data/constants';
import useConfidenceScore from 'hooks/use-confidence-score';

// AHA-6796 notify-mode heads-up on Choose Systems: a persistent,
// non-blocking banner shown only when the score sits below a NOTIFY-mode
// threshold. Renders nothing for block mode, at/above threshold (strict
// less-than), or without an applicable score.
export default function ConfidenceGateBanner() {
  const score = useConfidenceScore();

  if (
    !score?.hardGate ||
    score.hardGate.mode !== 'notify' ||
    score.overall >= score.hardGate.threshold
  ) {
    return null;
  }

  return (
    <div className='rounded-lg border border-yellow-200 bg-yellow-50 px-4 py-2 text-sm text-yellow-800'>
      {confidenceGateMessages.notifyBanner(
        score.overall,
        score.hardGate.threshold
      )}
    </div>
  );
}
